export enum CopyModeEnum {
  CONTAINER = "container",
  ICON = "icon",
  EXTERNAL_LINK = "external-link",
  NONE = "none",
}
